import moment from "moment";

const validation = {
  // validation as requested from spmf
  multipleValidationIdNumber(data) {
    const errorList = [];
    const idList = [];
    data.forEach((application, index) => {
      const id1 = application.ID_Number__c;
      const id2 = application.beneficiary.ID_Number__c;
      const dob1 = application.beneficiary.Date_of_Birth__c;
      console.log(dob1);
      const age = Math.floor(
        (new Date() - new Date(dob1).getTime()) / 3.15576e10
      );
      console.log(age);

      const validId1 = validateNRIC(id1);
      const validId2 = validateNRIC(id2);

      !validId1 &&
        errorList.push({
          type: "format",
          row: index,
          column: "ID_Number__c",
          category: "nricError",
        });
      !validId2 &&
        errorList.push({
          type: "format",
          row: index,
          column: "Beneficiary.ID_Number__c",
          category: "nricError",
        });

      if (id1.toUpperCase() === id2.toUpperCase()) {
        if (age < 18) {
          errorList.push({
            type: "duplicate",
            duplicate: "single-line",
            row: index,
            category: "nricError",
          });
        }
      }
      idList.push(id2);
    });

    const dupe = idList.filter((item, index) => idList.indexOf(item) !== index);
    if (dupe.length > 0) {
      dupe.forEach((id) => {
        errorList.push({
          type: "duplicate",
          duplicate: "multi-line",
          value: id,
          category: "nricError",
          column: "Beneficiary.ID_Number__c",
        });
      });
    }
    return errorList;
  },
  postalValidation(data) {
    const errorList = [];
    data.forEach((application, index) => {
      const validPostal = /^[0-9]{6,6}$/g.test(application.Postal_Code__c);
      !validPostal &&
        errorList.push({
          type: "format",
          row: index,
          column: "Postal_Code__c",
          category: "postalError",
        });
    });
    return errorList;
  },
  DOBValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      const dob1 = application.Date_of_Birth__c;
      const dob2 = application.beneficiary.Date_of_Birth__c;
      const validDob1 = moment(dob1, "YYYY/MM/DD", true).isValid();
      const validDob2 = moment(dob2, "YYYY/MM/DD", true).isValid();

      !validDob1 &&
        errorList.push({
          type: "format",
          row: index,
          column: "Applicant.Date_of_Birth__c",
          category: "DOBError",
        });
      !validDob2 &&
        errorList.push({
          type: "format",
          row: index,
          column: "Beneficiary.Date_of_Birth__c",
          category: "DOBError",
        });

      const age = Math.floor(
        (new Date() - new Date(dob2).getTime()) / 3.15576e10
      );
      !(age >= 6 && age <= 21) &&
        errorList.push({
          type: "ageRestrict",
          row: index,
          column: "Beneficiary.Date_of_Birth__c",
          category: "DOBError",
        });
    });

    return errorList;
  },
  phoneNumberValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      const validPhoneNumber = /^[0-9]{8,8}$/g.test(
        application.Mobile_Phone__c
      );
      !validPhoneNumber &&
        errorList.push({
          type: "format",
          row: index,
          column: "Phone_Number__c",
          category: "phoneNumberError",
        });
    });

    return errorList;
  },
  emailValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      if (application.Email__c) {
        const validEmail = (application.Email__c || "")
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        !validEmail &&
          errorList.push({
            type: "format",
            row: index,
            column: "Email__c",
            category: "emailError",
          });
      }
    });

    return errorList;
  },
  householdMembersValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      const members = Number(application.Total_number_of_household_members__c);
      if (isNaN(members) || members < 1) {
        errorList.push({
          type: "minimum",
          row: index,
          column: "Total_number_of_household_members__c",
          category: "householdMemberError",
        });
      }
    });

    return errorList;
  },
  monthlyHouseholdValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      const gross = application.Monthly_Gross_Income__c.replace(/\s/g, "");
      const validGrossIncome = /^[0-9]*(\.[0-9]{0,2})?$/g.test(gross);
      const greaterThanZero = gross >= 0;
      if (!greaterThanZero || !validGrossIncome) {
        errorList.push({
          type: "format",
          row: index,
          column: "Gross_Monthly_Household_Income__c",
          category: "monthlyHouseholdError",
        });
      }
    });
    return errorList;
  },
  monthlyPerCapitaValidation(data) {
    const errorList = [];

    data.forEach((application, index) => {
      const capita = application.Monthly_Gross_Per_Capita_Income__c.replace(
        /,/g,
        ""
      ).replace(/\s/g, "");
      const validGrossPerCapitaIncome = /^[0-9]*(\.[0-9]{0,2})?$/g.test(capita);
      const greaterThanZero = capita >= 0;
      if (!greaterThanZero || !validGrossPerCapitaIncome) {
        errorList.push({
          type: "format",
          row: index,
          column: "Monthly_Gross_Per_Capita_Income__c",
          category: "monthlyPerCapitaError",
        });
      }
    });
    return errorList;
  },
  picklistValidation(data) {
    const errorList = [];
    const NationalityList = ["Singaporean", "PR", "Others"];
    const NationalityStudentList = ["Singaporean", "PR"];
    const CountryList = ["Singapore"];
    const MaritalList = [
      "Single",
      "Married",
      "Divorced",
      "Separated",
      "Widowed",
    ];
    const HousingList = [
      "HDB 1 Room",
      "HDB 2 Room",
      "HDB 3 Room",
      "HDB 4 Room",
      "HDB 5 Room",
      "Interim Rental Housing",
      "Transitional Shelter",
      "Crisis Shelter",
      "Homeless",
      "Condominiums & Other Apartments/Landed",
    ];
    const yearList = [1, 2, 3, 4, 5, 6];
    const yearListgroup = [7, 8, 9, 10, 11, 12];

    data.forEach((application, index) => {
      application.Nationality__c &&
        !NationalityList.includes(application.Nationality__c) &&
        errorList.push({
          type: "picklist-Nationality__c",
          row: index,
          column: "Nationality__c",
          category: "picklistError",
        });

      application.beneficiary.Nationality__c &&
        !NationalityStudentList.includes(
          application.beneficiary.Nationality__c
        ) &&
        errorList.push({
          type: "picklist-StudentNationality__c",
          row: index,
          column: "Beneficiary.Nationality__c",
          category: "picklistError",
        });

      application.Country__c &&
        !CountryList.includes(application.Country__c) &&
        errorList.push({
          type: "picklist-Country__c",
          row: index,
          column: "Country__c",
          category: "picklistError",
        });

      application.Marital_Status__c &&
        !MaritalList.includes(application.Marital_Status__c) &&
        errorList.push({
          type: "picklist-Marital_Status__c",
          row: index,
          column: "Marital_Status__c",
          category: "picklistError",
        });

      application.Flat_Type__c &&
        !HousingList.includes(application.Flat_Type__c) &&
        errorList.push({
          type: "picklist-Flat_Type__c",
          row: index,
          column: "Flat_Type__c",
          category: "picklistError",
        });

      const applyingYear = Number(
        application.beneficiary.Applying_to_Level_Year__c
      );

      //changed by me :- hemant sharma

      // application.beneficiary.Applying_to_Level_Year__c &&
      //   !yearList.includes(
      //     Number(application.beneficiary.Applying_to_Level_Year__c)
      //   ) &&
      //   errorList.push({
      //     type: "picklist-Applying_to_Level_Year__c",
      //     row: index,
      //     column: "Beneficiary.Applying_to_Level_Year__c",
      //     category: "picklistError",
      //   });

      if (
        applyingYear &&
        !yearList.includes(applyingYear) &&
        !yearListgroup.includes(applyingYear) &&
        applyingYear < 13 // Ensures that values 13 and above are valid
      ) {
        errorList.push({
          type: "picklist-Applying_to_Level_Year__c",
          row: index,
          column: "Beneficiary.Applying_to_Level_Year__c",
          category: "picklistError",
        });
      }
    });
    return errorList;
  },
  errorMessage: {
    nricError: {
      format:
        "ID number is in the wrong format. ID number must consist of 1 letter, 7 digits and 1 final letter. There should be no spacing behind the ID number",
    },
    postalError: {
      format: "Postal code must be 6 digits only",
    },
    DOBError: {
      format: "DOB must follow the valid format (yyyy/mm/dd)",
      ageRestrict: "Beneficiary’s age must be 6-21 years old",
    },
    phoneNumberError: {
      format: "Phone number must be 8 digits only",
    },
    emailError: {
      format: "Email address is invalid",
    },
    monthlyHouseholdError: {
      format:
        "Gross monthly household income must be 0 or higher (up to 2 decimal points)",
    },
    monthlyPerCapitaError: {
      format:
        "Gross monthly per capita income must be 0 or higher (up to 2 decimal points)",
    },
    householdMemberError: {
      minimum: "Household Member must be 1 or higher",
    },
    picklistError: {
      "picklist-Nationality__c": "Applicant must be Singaporean/PR/Others only",
      "picklist-StudentNationality__c":
        "Beneficiary must be Singaporean/PR only",
      "picklist-Country__c": "Country must be Singapore only",
      "picklist-Marital_Status__c":
        "Marital status must be Single/Married/Divorced/Separated/Widowed only",
      "picklist-Flat_Type__c":
        "Flat type must be HDB 1 Room/HDB 2 Room/HDB 3 Room/HDB 4 Room/HDB 5 Room/Interim Rental Housing/Transitional Shelter/Crisis Shelter/Homeless/Condominiums & Other Apartments/Landed only",
      "picklist-Applying_to_Level_Year__c": "Year of study must be 1-6 only",
    },
  },
};

function validateNRIC(str) {
  if (str.length != 9) return false;

  str = str.toUpperCase();

  var i,
    icArray = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;

  var weight = 0;
  for (i = 1; i < 8; i++) {
    weight += icArray[i];
  }

  var offset = icArray[0] == "T" || icArray[0] == "G" ? 4 : 0;
  var temp = (offset + weight) % 11;

  var st = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
  var fg = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K"];

  var theAlpha;
  if (icArray[0] == "S" || icArray[0] == "T") {
    theAlpha = st[temp];
  } else if (icArray[0] == "F" || icArray[0] == "G") {
    theAlpha = fg[temp];
  }

  return icArray[8] === theAlpha;
}
export default validation;



//////////////////
// WEBPACK FOOTER
// ./src/components/BeneUpload/validation.js
// module id = 475
// module chunks = 0